import styled, { css } from 'styled-components';

type BaseProps = {
  isSelected?: boolean;
};

export const Container = styled.div<BaseProps>`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 2px solid #0b29fb;
    `}
`;

export const StatusWrap = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfosWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const BaseName = styled.span<BaseProps>`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;

export const Address = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;
